/* Clon uro — ajustes propios del clon sobre el tema fuente (Shrine PRO de la tienda fuente), en Shopping Fast.
 * 1. Packs reconstruidos (uro-kb, antes Kaching Bundles): elegir una barra la marca y guarda su indice.
 * 2. Releasit de Shopping Fast: su boton se viste como el "Añadir Al Carrito | 40% De Dto" de la fuente, y al abrir el
 *    formulario se marca la oferta del mismo indice que el pack elegido (1, 2 o 3 botes).
 * 3. Los otros botones de compra de la fuente (la barra fija y "Pruébelo hoy sin riesgo") abren el mismo formulario.
 * Observadores convergentes (gotchas §E): comparan antes de escribir y se apagan solos.
 */
(function () {
  'use strict';
  var RSI_BTN = '._rsi-buy-now-button', RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open',
      RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
  var TEXTO_BOTON = 'Añadir Al Carrito | 40% De Dto ➜';

  // ---------- 1. estilo del boton de Releasit, igual al de la fuente
  var css = document.createElement('style');
  css.textContent =
    '.main-product-atc.uro-oculto{display:none!important}' +
    '.uro-landing ' + RSI_BTN + ',body ' + RSI_BTN + '._rsi-buy-now-button-product{background:rgb(73,148,98)!important;color:#fff!important;' +
    'border-radius:4px!important;border:0!important;box-shadow:none!important;min-height:49px!important;' +
    'font-family:Helvetica,Arial,sans-serif!important;font-size:19px!important;font-weight:400!important;letter-spacing:1px!important;' +
    'text-transform:none!important;animation:none!important}' +
    'body ' + RSI_BTN + '._rsi-buy-now-button-product *{color:#fff!important;font-family:inherit!important;font-size:inherit!important;' +
    'font-weight:inherit!important;letter-spacing:inherit!important;text-transform:none!important}' +
    // la fuente no tiene icono de carrito en el boton: con el icono, el texto de 19 px se partia en dos lineas
    'body ' + RSI_BTN + '._rsi-buy-now-button-product svg,body ' + RSI_BTN + '._rsi-buy-now-button-product img{display:none!important}';
  document.head.appendChild(css);

  var ESTILO = { 'background': 'rgb(73, 148, 98)', 'color': 'rgb(255, 255, 255)', 'border-radius': '4px', 'border': '0px',
    'box-shadow': 'none', 'min-height': '49px', 'font-family': 'Helvetica, Arial, sans-serif',
    // 19 px como la fuente, pero sin partirse: en Android no hay Helvetica y el sustituto es más ancho (la flecha bajaba sola)
    'font-size': 'min(19px, 4.5vw)', 'white-space': 'nowrap',
    'font-weight': '400', 'letter-spacing': '1px', 'text-transform': 'none', 'animation': 'none', 'padding': '0px 12px' };
  function pintar(b) {
    Object.keys(ESTILO).forEach(function (k) {
      if (b.style.getPropertyValue(k) !== ESTILO[k] || b.style.getPropertyPriority(k) !== 'important') b.style.setProperty(k, ESTILO[k], 'important');
    });
  }
  function vestirBoton(b) {
    // el texto de Releasit va en el ultimo nodo con texto; se cambia una sola vez
    if (b.getAttribute('data-uro-vestido')) return;
    var nodos = [], w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) if (w.currentNode.nodeValue.trim()) nodos.push(w.currentNode);
    if (!nodos.length) return;
    nodos[nodos.length - 1].nodeValue = TEXTO_BOTON;
    b.setAttribute('data-uro-vestido', '1');
    pintar(b);
    // Releasit pone su color con estilo en linea y !important: se repinta si lo vuelve a poner (solo 8 s, comparando antes)
    var mo = new MutationObserver(function () { pintar(b); });
    mo.observe(b, { attributes: true, attributeFilter: ['style'] });
    setTimeout(function () { mo.disconnect(); }, 8000);
    // con el boton de Releasit puesto, el "Añadir al carrito" del tema sobra (iria al carrito, no al formulario)
    document.querySelectorAll('.main-product-atc:not([id^="SectionAtcBtn-"])').forEach(function (a) {
      if (!a.classList.contains('uro-oculto')) a.classList.add('uro-oculto');
    });
  }
  var t0 = Date.now();
  (function buscar() {
    var bs = document.querySelectorAll('product-info ' + RSI_BTN + ', .product__info-container ' + RSI_BTN);
    bs.forEach(vestirBoton);
    if (Date.now() - t0 < 8000 && (!bs.length || [].some.call(bs, function (b) { return !b.getAttribute('data-uro-vestido'); })))
      setTimeout(buscar, 300);
  })();

  // ---------- 2. packs
  window.URO_IDX = 0;
  function elegir(idx) {
    idx = Number(idx) || 0;
    window.URO_IDX = idx;
    document.querySelectorAll('.uro-kb__bar[data-uro-idx]').forEach(function (bar) {
      var si = Number(bar.getAttribute('data-uro-idx')) === idx;
      if (bar.classList.contains('uro-kb__bar--selected') !== si) bar.classList.toggle('uro-kb__bar--selected', si);
      var r = bar.querySelector('input[type=radio]');
      if (r && r.checked !== si) r.checked = si;
    });
  }
  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.uro-kb__bar[data-uro-idx]');
    if (bar) { e.preventDefault(); elegir(bar.getAttribute('data-uro-idx')); }
  });
  var pre = document.querySelector('.uro-kb__bar--selected[data-uro-idx]');
  elegir(pre ? pre.getAttribute('data-uro-idx') : 0);

  // ---------- 3. al abrir el formulario de Releasit, marcar la oferta del pack elegido
  function sincronizar() {
    var inicio = Date.now(), clics = 0, obs = null, timer = null;
    function intentar() {
      var modal = document.querySelector(RSI_MODAL);
      if (!modal) return false;
      var ofertas = modal.querySelectorAll(RSI_OFFER);
      if (!ofertas.length) return false;
      var o = ofertas[Math.min(window.URO_IDX, ofertas.length - 1)];
      if (o.classList.contains(RSI_SEL)) return true;
      if (clics < 6) { clics++; (o.querySelector('._rsi-quantity-offers-offer') || o).click(); }
      return false;
    }
    function fin() { if (obs) obs.disconnect(); if (timer) clearInterval(timer); }
    if (intentar()) return;
    obs = new MutationObserver(function () { if (intentar() || Date.now() - inicio > 6000) fin(); });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    timer = setInterval(function () { if (intentar() || Date.now() - inicio > 6000) fin(); }, 300);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(RSI_BTN)) sincronizar();
  }, true);

  // ---------- 4. la barra fija y "Pruébelo hoy sin riesgo" abren el mismo formulario
  function abrirFormulario() {
    var b = document.querySelector('product-info ' + RSI_BTN + ', .product__info-container ' + RSI_BTN) || document.querySelector(RSI_BTN);
    if (b) { b.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var otro = e.target.closest && e.target.closest('[id^="SectionAtcBtn-"], .sticky-atc button, [class*="sticky-atc"] button, [class*="sticky-atc"] [type=submit]');
    if (!otro || otro.closest(RSI_BTN)) return;
    if (abrirFormulario()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
